export const defaultState = {
  unsignedTmpFiles: [],
  signedFiles: [],
};
